const func = $target => {
    function reloadResults($target) {
        var dataId = $target.attr('data-id'),
            locator = '[data-id="' + dataId + '"] .container';
        $($pageLinks).on('click', function(e) {
            e.preventDefault();
            var param = String(this.href);

            $target.load(param + ' ' + locator, function() {
                $pageLinks = $target.find('.pagination a');
                reloadResults($target);
                new LazyLoad({
                    elements_selector: '[loading=lazy]',
                    use_native: false
                });
            });
            $('html, body').animate({
                scrollTop: $target.offset().top - 20
            }, 'fast');

            window.history.pushState(null, null, param);
        });
    }

    if ( ($target.data('mod') !== 'storeProductListing') || (Boolean($target.attr('data-mod')) != true) ) {

        var $pageLinks = $target.find('.pagination a');
        if ($pageLinks.length != 0) {
            reloadResults($target);
        }

        window.addEventListener('popstate', function(e) {
            var url = e.target.window.location.href,
                selector = '[data-id="' + $target.attr('data-id') + '"] .container';
            $target.load(url + ' ' + selector, function() {
                $pageLinks = $target.find('.pagination a');
                reloadResults($target);
                new LazyLoad({
                    elements_selector: '[loading=lazy]',
                    use_native: false
                });
            });
        });
    }

};

export default func;